import { MealPeriodEnum, MenuTemplateStateEnum, ProductEnum } from '@/api';

import type { MenuTemplateFilters } from './types';

export const MENU_ITEMS_PER_PAGE = 25;

export const PRODUCT_TYPE_LABEL: Partial<Record<ProductEnum, string>> = {
  [ProductEnum.POPUP]: 'Popup/ Cafe',
  [ProductEnum.DELIVERY]: 'Delivery',
  [ProductEnum.CATERING]: 'Catering',
};

export const MEAL_PERIOD_LABEL: Record<MealPeriodEnum, string> = {
  [MealPeriodEnum.BREAKFAST]: 'Breakfast',
  [MealPeriodEnum.LUNCH]: 'Lunch',
  [MealPeriodEnum.DINNER]: 'Dinner',
  [MealPeriodEnum.APPETIZERS]: 'Appetizers',
};

export const MENU_STATE_LABEL: Record<MenuTemplateStateEnum, string> = {
  [MenuTemplateStateEnum.PUBLISHED]: 'Published',
  [MenuTemplateStateEnum.APPROVED]: 'Approved',
  [MenuTemplateStateEnum.PENDING_APPROVAL]: 'Pending Approval',
  [MenuTemplateStateEnum.DRAFT]: 'Draft',
};

// Draft intentionally has no entry: a missing map lookup is what tells
// MenuStatusHelpIcon to render nothing, rather than a separate conditional.
export const MENU_STATE_HELP_TEXT: Partial<Record<MenuTemplateStateEnum, string>> = {
  [MenuTemplateStateEnum.PENDING_APPROVAL]:
    'The menu or any changes are awaiting review by Fooda and will not be live on upcoming events yet',
  [MenuTemplateStateEnum.APPROVED]:
    'The menu or any changes have been reviewed but will not be live on upcoming events until moved to Published by Fooda',
  [MenuTemplateStateEnum.PUBLISHED]:
    'This menu is now eligible for upcoming Fooda events, but the prior version may still be active on events for up to two weeks',
};

export const PRODUCT_TYPE_FILTER_OPTIONS: ProductEnum[] = [
  ProductEnum.POPUP,
  ProductEnum.DELIVERY,
  ProductEnum.CATERING,
];

export const MEAL_PERIOD_FILTER_OPTIONS: MealPeriodEnum[] = [
  MealPeriodEnum.BREAKFAST,
  MealPeriodEnum.LUNCH,
  MealPeriodEnum.DINNER,
  MealPeriodEnum.APPETIZERS,
];

export const STATE_FILTER_OPTIONS: MenuTemplateStateEnum[] = [
  MenuTemplateStateEnum.PUBLISHED,
  MenuTemplateStateEnum.APPROVED,
  MenuTemplateStateEnum.PENDING_APPROVAL,
];

export const DEFAULT_FILTERS: MenuTemplateFilters = {
  productTypes: PRODUCT_TYPE_FILTER_OPTIONS,
  mealPeriods: [],
  states: [],
};

export const NO_FILTER_MATCHES_TEXT = "You're all caught up!";

export const RECENT_UPDATE_TITLE =
  'This menu was recently updated, and you may be required to use the previous version for your upcoming events before the changes take effect. Check the Fooda POS or upcoming delivery manifests for the event-specific version.';

export const RECENT_UPDATE_MESSAGE = 'Reach out to your Fooda contact with any questions.';

export const SELECT_RESTAURANT_TEXT = 'Select a restaurant to view its menus';

export const MENU_EMPTY_IMAGE_SRC = '/assets/images/menu_list.svg';

export const MENU_ITEM_PLACEHOLDER_TOKEN = 'item_placeholder';
export const NO_IMAGE_PLACEHOLDER_SRC = '/assets/images/no_image_placeholder.svg';

export const NO_MENU_TEMPLATES_TITLE_TEXT = 'There are no menus for the restaurant';
export const NO_MENU_TEMPLATES_TEXT = `When you add a menu, it'll show up here`;
export const NO_MENU_ITEMS_TEXT = 'This menu has no items yet.';

export const OPTIONS_PREVIEW_ONLY_TEXT = 'Options preview only';
export const NO_OPTIONS_TEXT = 'No options for this item.';
export const OPTIONAL_LABEL = 'Optional';
export const REQUIRED_LABEL = 'Required';

export const MENU_TEMPLATES_HEADING = 'Menu templates';
export const CLEAR_FILTERS_TEXT = 'Clear filters';
export const MENU_LOAD_ERROR_TITLE = "Couldn't load this menu";
export const UNCATEGORIZED_CATEGORY_LABEL = 'Other';
export const UNTITLED_MENU_TEXT = 'Untitled menu';
export const OPTIONS_LABEL = 'Options';

export const DESCRIPTION_COLLAPSED_HEIGHT = 50;
export const SHOW_MORE_LABEL = 'Show more';
export const SHOW_LESS_LABEL = 'Show less';
